"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoolLocation = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const typeorm_1 = require("typeorm");
const uuid_1 = require("uuid");
const transformToDate_1 = require("../transformers/transformToDate");
const LocationImage_1 = require("./LocationImage");
const SellingPoint_1 = require("./SellingPoint");
let PoolLocation = class PoolLocation {
    _id = (0, uuid_1.v4)();
    locationId;
    radiusKm;
    sellingPoints = [];
    images = [];
    createdAt = new Date();
    createdBy;
    perex;
};
exports.PoolLocation = PoolLocation;
__decorate([
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], PoolLocation.prototype, "_id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", String)
], PoolLocation.prototype, "locationId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], PoolLocation.prototype, "radiusKm", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => SellingPoint_1.SellingPoint),
    __metadata("design:type", Array)
], PoolLocation.prototype, "sellingPoints", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => LocationImage_1.LocationImage),
    __metadata("design:type", Array)
], PoolLocation.prototype, "images", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], PoolLocation.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", String)
], PoolLocation.prototype, "createdBy", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", String)
], PoolLocation.prototype, "perex", void 0);
exports.PoolLocation = PoolLocation = __decorate([
    (0, typeorm_1.Entity)("poolLocations")
], PoolLocation);
//# sourceMappingURL=PoolLocation.js.map